import DefaultTable from '../DefaultTable/DefaultClass'

class AssortimentMarkupByQuantity extends DefaultTable {
    constructor(props) {
        super(props)

        this.filters_top = []

        this.filters_aside = []

        this.filters_aside = [...this.default_filters_aside, ...this.filters_aside]


        this.fields_data = [
            {
                tab: "COMMON",
                dataTab: [
                    {
                        box: [
                            {
                                name: 'id_doc',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false,
                            },
                            {
                                name: 'product',
                                type: 'text',
                                show_type: 'ReferenceField',
                                edit_type: 'ReferenceInput',
                                type_ext: {reference: 'Products', optionText: 'name', locale: true},
                                read_only: false,
                                flex: 1,
                            },

                        ]
                    },
                    {
                        box: [
                            {
                                name: 'date_from',
                                type: 'date',
                                show_type: 'DateField',
                                edit_type: 'DateInputComp',
                                read_only: false
                            },
                            {
                                name: 'date_to',
                                type: 'date',
                                show_type: 'DateField',
                                edit_type: 'DateInputComp',
                                read_only: false
                            },

                        ]
                    },
                    {
                        box: [
                            {
                                name: 'quantity',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false,
                            },
                            {
                                name: 'price',
                                type: 'float',
                                show_type: 'NumberField',
                                edit_type: 'NumberInputFloatComp',
                                read_only: false,
                            },

                            {
                                name: 'currency',
                                type: 'text',
                                show_type: 'ReferenceField',
                                edit_type: 'ReferenceInput',
                                type_ext: {reference: 'Currencies', optionText: 'name', locale: true},
                                read_only: false,
                            },
                        ]
                    },
                ]
            },
        ]
        this.fields_data = [...this.default_fields_data, ...this.fields_data]
    }
}

export default AssortimentMarkupByQuantity